import React, {useEffect, useState} from 'react';
import { Row, Col, Button, Upload, Icon} from 'antd';
import FieldBlock from '../../../field-block';
import DividerBlock from "../../../divider-block";
import {getWithTranslate} from "../../../../helpers/doc_type.helper";
import i18n from "../../../../i18n";

export default function EditRusLegalEntityDocs({
                                                 legalEntityData,
                                                 docFields,
                                                 setDocFields,
                                                 fieldsErrors,
                                                 isNeedPowerOfAttorneyForAPerson,
                                                 setIsNeedPowerOfAttorneyForAPerson,
                                                 isNDSPayer,
                                                 setIsNDSPayer,
                                                 isConsignor,
                                               }) {
    const [taxType, setTaxType] = useState(false);
    const legalEntityDataAliases = getWithTranslate('legalEntityDataAliases');
    useEffect(() => {
        if (legalEntityData.WorkWithNds === 1) {
            setIsNDSPayer(true);
        } else {
            setIsNDSPayer(false)
        }

        if (legalEntityData.LegalReason === 'Доверенность (ООО)') {
            setIsNeedPowerOfAttorneyForAPerson(true);
        } else {
            setIsNeedPowerOfAttorneyForAPerson(false)
        }

        setTaxType(legalEntityData.TaxType);
    }, [legalEntityData]);

    const getFieldErrors = (fieldName) => {
        return typeof fieldsErrors[fieldName] !== "undefined"
            ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
                return fieldErrors + "; " + error;
            })
            : null;
    };

    const getUploaderClass = (name, multiple = true) => {
       // const hasFiles = docFields[name] &&
         //   (Array.isArray(docFields[name]) ? docFields[name].length > 0 : true);
        const hasFiles = name in docFields;
        // Если нет файлов - возвращаем null, блок не отобразится
        if (!hasFiles) {
            return null;
        }
        return {
            multiple: multiple,
            showUploadList: true,
            onRemove: (file) => {
                setDocFields({...docFields, [name]: null});
            },
            beforeUpload: (file, fileList) => {
                if (multiple) {
                    if (docFields[name]) {
                        setDocFields({...docFields, [name]: docFields[name].concat(fileList)});
                    } else {
                        setDocFields({...docFields, [name]: fileList});
                    }
                } else {
                    setDocFields({...docFields, [name]: file});
                }
                return false;
            },
            fileList: docFields[name],
            listType: 'picture',
        };
    };

    //TODO
    const docsRenderer = () => {
        if (legalEntityData.OrgFormId === 26) {
            return (
                <>
                    {'certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority"
                                        getErrors={getFieldErrors}>
                                <Upload
                                    defaultFileList={docFields.certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority}
                                    className="single-btn-upload" {...getUploaderClass('certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'certificateOfStateRegistration' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="certificateOfStateRegistration" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.certificateOfStateRegistration}
                                        className="single-btn-upload" {...getUploaderClass('certificateOfStateRegistration', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.certificateOfStateRegistration}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'registeredMemorandumOfAssociation' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="registeredMemorandumOfAssociation" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.registeredMemorandumOfAssociation}
                                        className="single-btn-upload" {...getUploaderClass('registeredMemorandumOfAssociation', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.registeredMemorandumOfAssociation}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'decisionToCreate' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="decisionToCreate" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.decisionToCreate}
                                        className="single-btn-upload" {...getUploaderClass('decisionToCreate', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.decisionToCreate}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'requisites' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="requisites" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.requisites}
                                        className="single-btn-upload" {...getUploaderClass('requisites', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.requisites}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {!(!legalEntityData.IsProprietorType && isConsignor) && 'copyOfThePassport' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="copyOfThePassport" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.copyOfThePassport}
                                        className="single-btn-upload" {...getUploaderClass('copyOfThePassport', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.copyOfThePassport}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                </>
            );
        }

        if (legalEntityData.IsProprietorType) {
            return (
                <>
                    {'certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority"
                                        getErrors={getFieldErrors}>
                                <Upload
                                    defaultFileList={docFields.certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority}
                                    className="single-btn-upload" {...getUploaderClass('certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority')}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.certificateOfRegistrationIndividualEntrepreneurWithTaxAuthority}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'partnerCard' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="partnerCard" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.partnerCard}
                                        className="single-btn-upload" {...getUploaderClass('partnerCard', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.partnerCard}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'copyOfThePassport' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="copyOfThePassport" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.copyOfThePassport}
                                        className="single-btn-upload" {...getUploaderClass('copyOfThePassport', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.copyOfThePassport}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'certificateOfStateRegistration' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="certificateOfStateRegistration" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.certificateOfStateRegistration}
                                        className="single-btn-upload" {...getUploaderClass('certificateOfStateRegistration')}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.certificateOfStateRegistration}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                </>
            )
        } else {
            return (
                <>
                    {'partnerCard' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="partnerCard" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.partnerCard}
                                        className="single-btn-upload" {...getUploaderClass('partnerCard', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.partnerCard}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {!isConsignor && 'copyOfThePassport' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="copyOfThePassport" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.copyOfThePassport}
                                        className="single-btn-upload" {...getUploaderClass('copyOfThePassport', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.copyOfThePassport}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}

                    {'certificateOfStateRegistration' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="certificateOfStateRegistration" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.certificateOfStateRegistration}
                                        className="single-btn-upload" {...getUploaderClass('certificateOfStateRegistration')}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.certificateOfStateRegistration}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'protocolOfTheGeneralMeetingOfParticipants' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="protocolOfTheGeneralMeetingOfParticipants" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.protocolOfTheGeneralMeetingOfParticipants}
                                        className="single-btn-upload" {...getUploaderClass('protocolOfTheGeneralMeetingOfParticipants', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.protocolOfTheGeneralMeetingOfParticipants}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {!isConsignor && 'proofOfOwnership'in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="proofOfOwnership" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.proofOfOwnership}
                                        className="single-btn-upload" {...getUploaderClass('proofOfOwnership', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.proofOfOwnership}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'charterWithAllAmendments' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="charterWithAllAmendments" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.charterWithAllAmendments}
                                        className="single-btn-upload" {...getUploaderClass('charterWithAllAmendments', true)}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.charterWithAllAmendments}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {'registrationOfALegalEntityWithTaxAuthority' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="registrationOfALegalEntityWithTaxAuthority" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.registrationOfALegalEntityWithTaxAuthority}
                                        className="single-btn-upload" {...getUploaderClass('registrationOfALegalEntityWithTaxAuthority')}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.registrationOfALegalEntityWithTaxAuthority}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                    {isNeedPowerOfAttorneyForAPerson && 'powerOfAttorneyForAPerson' in docFields && (
                        <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                            <FieldBlock name="powerOfAttorneyForAPerson" getErrors={getFieldErrors}>
                                <Upload defaultFileList={docFields.powerOfAttorneyForAPerson}
                                        className="single-btn-upload" {...getUploaderClass('powerOfAttorneyForAPerson')}>
                                    <Button htmlType="button">
                                        <Icon type="upload"
                                              className="single-btn-upload__icon"/> {legalEntityDataAliases.powerOfAttorneyForAPerson}
                                    </Button>
                                </Upload>
                            </FieldBlock>
                        </Col>
                    )}
                </>
            );
        }
    }

    return (
        <Row gutter={20}>
            <DividerBlock label={i18n.t('modals.modalEditLegalEntityDocs.divider.docs')}/>

            {docsRenderer()}

            {(isNDSPayer && !isConsignor) && (
                ((taxType === 'common_nds') && (
                    <>
                        {'incomeTaxForTheLastReportingPeriod' in docFields && (
                            <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                                <FieldBlock name="incomeTaxForTheLastReportingPeriod" getErrors={getFieldErrors}>
                                    <Upload defaultFileList={docFields.incomeTaxForTheLastReportingPeriod}
                                            fileList={docFields.incomeTaxForTheLastReportingPeriod}
                                            className="single-btn-upload" {...getUploaderClass('incomeTaxForTheLastReportingPeriod', true)}>
                                        <Button htmlType="button">
                                            <Icon type="upload"
                                                  className="single-btn-upload__icon"/> {legalEntityDataAliases.incomeTaxForTheLastReportingPeriod}
                                        </Button>
                                    </Upload>
                                </FieldBlock>
                            </Col>
                        )}
                        {'nDSReturnForTheLastReportingPeriod' in docFields && (
                            <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                                <FieldBlock name="nDSReturnForTheLastReportingPeriod" getErrors={getFieldErrors}>
                                    <Upload defaultFileList={docFields.nDSReturnForTheLastReportingPeriod}
                                            fileList={docFields.nDSReturnForTheLastReportingPeriod}
                                            className="single-btn-upload" {...getUploaderClass('nDSReturnForTheLastReportingPeriod', true)}>
                                        <Button htmlType="button">
                                            <Icon type="upload"
                                                  className="single-btn-upload__icon"/> {legalEntityDataAliases.nDSReturnForTheLastReportingPeriod}
                                        </Button>
                                    </Upload>
                                </FieldBlock>
                            </Col>
                        )}
                        {'bookkeepingBalance' in docFields && (
                            <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                                <FieldBlock name="bookkeepingBalance" getErrors={getFieldErrors}>
                                    <Upload defaultFileList={docFields.bookkeepingBalance}
                                            fileList={docFields.bookkeepingBalance}
                                            className="single-btn-upload" {...getUploaderClass('bookkeepingBalance', true)}>
                                        <Button htmlType="button">
                                            <Icon type="upload"
                                                  className="single-btn-upload__icon"/> {legalEntityDataAliases.bookkeepingBalance}
                                            период
                                        </Button>
                                    </Upload>
                                </FieldBlock>
                            </Col>
                        )}
                        {'certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget' in docFields && (
                            <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                                <FieldBlock name="certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget"
                                            getErrors={getFieldErrors}>
                                    <Upload
                                        defaultFileList={docFields.certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget}
                                        fileList={docFields.certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget}
                                        className="single-btn-upload" {...getUploaderClass('certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget', true)}>
                                        <Button htmlType="button">
                                            <Icon type="upload"
                                                  className="single-btn-upload__icon"/> {legalEntityDataAliases.certificateFromIFNSOnTheStatusOfSettlementsWithTheBudget}
                                        </Button>
                                    </Upload>
                                </FieldBlock>
                            </Col>
                        )}
                        {'staffingTable' in docFields && (
                            <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                                <FieldBlock name="staffingTable" getErrors={getFieldErrors}>
                                    <Upload defaultFileList={docFields.staffingTable} fileList={docFields.staffingTable}
                                            className="single-btn-upload" {...getUploaderClass('staffingTable', true)}>
                                        <Button htmlType="button">
                                            <Icon type="upload"
                                                  className="single-btn-upload__icon"/> {legalEntityDataAliases.staffingTable}
                                        </Button>
                                    </Upload>
                                </FieldBlock>
                            </Col>
                        )}
                    </>
                ))
                ||
                ((taxType === 'simple_nds') && (
                    <>
                        {'documentsConfirmingTax' in docFields && (
                            <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 15px 0'}}>
                                <FieldBlock name="documentsConfirmingTax" getErrors={getFieldErrors}>
                                    <Upload defaultFileList={docFields.documentsConfirmingTax}
                                            fileList={docFields.documentsConfirmingTax}
                                            className="single-btn-upload" {...getUploaderClass('documentsConfirmingTax', true)}>
                                        <Button htmlType="button">
                                            <Icon type="upload"
                                                  className="single-btn-upload__icon"/>{legalEntityDataAliases.documentsConfirmingTax}
                                        </Button>
                                    </Upload>
                                </FieldBlock>
                            </Col>
                        )}
                    </>
                ))
            )}
        </Row>
    );
}
